import React from 'react';
import { styled } from '../styles';
export default styled(({ children, ...rest }) => (React.createElement("a", { ...rest, rel: "noreferrer" }, children)))(({ theme: { palette } }) => ({
    color: palette.secondary.main,
    '&:hover': {
        color: palette.secondary.dark,
        textDecoration: 'underline',
    },
}));
//# sourceMappingURL=Link.js.map